import {
    DEALERSETDSRLIMITS_SUCCESS,
    DEALERSETDSRLIMITS_FAILED,
    RESET_DEALERSETDSRLIMITS,
    LOADING_DEALERSETDSRLIMITS,
    NETWORK_ERROR_DEALERSETDSRLIMITS
} from "../types/index"
import { dealerServices } from "../../config/axios";

const resetDealerSetDsrLimits = () => {
    return { type: RESET_DEALERSETDSRLIMITS };
};

const dealerSetDsrLimits = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERSETDSRLIMITS });
    await dealerServices
        .post("setDsrLimits", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerSetDsrLimitssuccess(res.data));
                    break;
                default:
                    dispatch(dealerSetDsrLimitsFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERSETDSRLIMITS,
                payload: err
            });
        });
};
function dealerSetDsrLimitssuccess(data) {
    return {
        type: DEALERSETDSRLIMITS_SUCCESS,
        payload: data
    };
}
function dealerSetDsrLimitsFailed(data) {
    return {
        type: DEALERSETDSRLIMITS_FAILED,
        payload: data
    };
}

export { resetDealerSetDsrLimits, dealerSetDsrLimits }